import { handleActions } from 'redux-actions';
import LoadingOverlayModel from 'models/utils/common/loading-overlay-model';

import {
  setLoadingOverlay,
  clearLoadingOverlay,
} from 'store/actions/common/loading-overlay-actions';

export default handleActions(
  {
    [setLoadingOverlay]: (loadingOverlay, { payload }) => {
      return loadingOverlay.setLoading(payload);
    },
    [clearLoadingOverlay]: () => {
      return new LoadingOverlayModel();
    },
  },
  new LoadingOverlayModel(),
);
